<template>
  <div class="songs-player-poster-box">
    <v-img :path="poster" class="poster" />
    <div class="song-title" v-html="title"></div>
  </div>
</template>

<script>
import "./index.scss";

export default {
  computed: {
    poster() {
      return this.bg;
    },
    title() {
      return this.data.title;
    },
  },
  inject: ["data", "bg"],
};
</script>
